import base_ds, {CrudOperates} from '@/services/base_datasource_service'
import DataSource from 'devextreme/data/data_source';
import {BaseEntity} from './base_types';
import { AxiosResponse } from "axios";
import { IResponseResult } from "@/services/data/base_types";
import AuthService from "@/services/auth_service";
import UserAccessService from "@/services/user_access_service";
import {EcoObjectType, FilialNodeTree} from "@/services/models-service";
import _ from "lodash";
import request from "@/utils/request";
import notify_service from "@/services/notify_service";

export const user_route_ns = 'admin/user';
export const company_route_ns = 'companies';
export const active_company_route_ns = 'companies/active';

export class DeviceFailureUser extends BaseEntity {
  failure_code: string = '';
  user_id: string | null = null;
  send_email: boolean = false;
  play_sound: boolean = false;
}

export class User extends BaseEntity {
  external: string = ''
  login: string = ''
  password: string = ''
  full_name: string = ''
  description: string = ''
  role: string | number | null = null
  builtin = false
  email: string = '';
  id_eco_heat_node: number | null = null;
  eco_heat_nodes: number[] = [];
  disabled: boolean | null = null;
  ad_guid: string | null = null;
  storage_access: string | null = null;
}

export interface UserEcoHeatNode {
  id_eco_heat_node: number;
}

export interface AdUserEntity {
  sAMAccountName: string; // Логин в пользователя в AD
  cn: string; // Имя
  displayName: string; // Фамилия
  mail: string | null; /// email
  objectGUID: string; // uid объекта AD
  is_selected?: boolean; //Привязана ли данная запись AD к пользователю
}

export interface UserADExistence {
  user_id: string;
  ad_exists: boolean;
}

class UserManagerService {
  internalUserDataSource: DataSource;
  userDataSource: DataSource;
  userCrud: CrudOperates;

  public selected_row: any = null;
  public current_user: any = null;

  public edit_popup: any = {
    visible: false,
    edit_mode: false,
    is_external: false,
  }

  constructor() {
    this.internalUserDataSource = base_ds.getBaseDataSource(user_route_ns, 'id');
    this.userDataSource = base_ds.getBaseDataSource(user_route_ns, 'id');

    this.userCrud = base_ds.getBaseCrud(user_route_ns);
  }

  public async getCurrentUser() {
    const current_id = AuthService.getUserIdFromToken();

    try {
      const resp: any = await request({
        url: `${user_route_ns}/${current_id}`,
        method: 'get'
      });

      if(resp) {
        this.current_user = resp;
      }

    } catch (e) {
      console.error(e);
    }
  }

  public async get(): Promise<IResponseResult<User[]>> {
    const response: AxiosResponse["data"] = await this.userCrud.get();
    if (response && response.data) {
      return {data: response.data as User[] };
    } else {
      return { data: null, message: "" };
    }
  }

  async saveUser(user: User) {
    return this.userCrud.save(user);
  }

  async deleteUser(user: User) {
    return this.userCrud.delete(user.id);
  }

  async getAdUsersList(filter: string):Promise<IResponseResult<AdUserEntity[]>> {
    // получение списка пользователей Active Directory
    try {

      const resp: AxiosResponse["data"] = await request({
        url: `${user_route_ns}/ad_users`,
        method: 'get',
        params: { filter }
      });

      if (resp.data) {
        return { data: resp.data }
      } else {
        throw new Error('Получен пустой список');
      }
    } catch (e) {
      notify_service.error(`Ошибка запроса списка пользователей AD: ${e}`);
      return { data: null };
    }
  }

  /**
   * Проверка наличия пользователей в Active Directory
   */
  async checkUsersExistInAD(): Promise<UserADExistence[] | null> {
    try {
      const resp: AxiosResponse["data"] = await request({
        url: `${user_route_ns}/exists_in_ad`,
        method: 'get',
      });
      if (resp && Array.isArray(resp)) {
        return resp as UserADExistence[];
      } else if (resp && resp.data && Array.isArray(resp.data)) {
        return resp.data as UserADExistence[];
      } else {
        throw new Error('Некорректный ответ от сервера');
      }
    } catch (e) {
      notify_service.error(`Ошибка проверки пользователей в AD: ${e}`);
      return null;
    }
  }

  setEditPopupVisible(vis: boolean, is_ext: boolean = false) {
    this.edit_popup.is_external = is_ext || false;
    this.edit_popup.visible = vis;
  }

  setEditPopupMode(vis: boolean) {
    this.edit_popup.edit_mode = vis;
  }

  setCurrentRow(data: User | null) {
    this.selected_row = data;
  }
}

export default new UserManagerService();
